import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import Footer from '../Components/Footer/Footer'
import FormModal from '../Components/FormModal/FormModal'

const Layout = ({ children, handleShow, handleClose, show }) => {
  return (
    <React.Fragment>
      <Navbar />
      <FormModal show={show} handleClose={handleClose} />
      <div>{children}</div>
      <Footer handleShow={handleShow} />
    </React.Fragment>
  )
}

export default Layout
